export default {
  OtherVoucherList: {
    TitleName: 'Chứng từ nghiệp vụ khác',
  },
};
